/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var TechPcDesktopIcon16Solid = forwardRef('TechPcDesktopIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M7.75 1A1.75 1.75 0 0 0 6 2.75V3h3.5A2.5 2.5 0 0 1 12 5.5v5a2.5 2.5 0 0 1-2.273 2.49c.173.296.273.642.273 1.01 0 .364-.097.706-.268 1h3.518A1.75 1.75 0 0 0 15 13.25V2.75A1.75 1.75 0 0 0 13.25 1h-5.5Z" }),
        React.createElement("path", { d: "M2 4a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h2.5v1H3a1 1 0 1 0 0 2h5a1 1 0 1 0 0-2H6.5v-1H9a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H2Z" })));
});
